import { gql } from 'apollo-angular';
import { User } from '../../entities/user/user';

export const ENABLE_USER_MUTATION = gql`
mutation enableUser($userId: UUID) {
  enableUser(userId: $userId) {
    id
    enabled
  }
}
`;

export const DISABLE_USER_MUTATION = gql`
mutation disableUser($userId: UUID) {
  disableUser(userId: $userId) {
    id
    enabled
  }
}
`;

export const UPDATE_USER_MUTATION = gql`
mutation updateUser($input: UserInput) {
  updateUser(userInput: $input) {
    id
  }
}
`;

export const CHANGE_SITE_MUTATION = gql`
mutation changeSite($user: UserInput) {
  changeSite(user: $user) {
    id
  }
}
`;

export const RESET_PASSWORD_MUTATION = gql`
mutation resetPassword($id: UUID, $password: String, $requiredActions: [UserActions]) {
  resetPassword(userId: $id, password: $password, requiredActions: $requiredActions) {
    id
  }
}
`;

export const CREATE_USER_MUTATION = gql`
mutation createUser($input: UserInput) {
  createUser(userInput: $input) {
    id
  }
}
`;

export const UPDATE_AUTHORITIES_MUTATION = gql`
mutation updateAuthorities($user: UserInput) {
  updateAuthorities(user: $user) {
    id
  }
}
`;

export const CHECK_EMAIL_MUTATION = gql`
query checkEmailAddress($email: String) {
  checkEmailAddress(emailAddress: $email)
}
`;

export const SWITCH_TENANT_MUTATION = gql`
mutation switchTenant($tenant: String) {
  switchTenant(tenant: $tenant)
}
`;

export const SET_REQUIRED_ACTIONS = gql`
mutation setRequiredActions($id: UUID, $requiredActions: [UserActions]) {
  setRequiredActions(userId: $id, requiredActions: $requiredActions) {
    id
  }
}
`;

export const UPDATE_LICENCE_TYPE = gql`
mutation updateLicenceType($userId: UUID, $licenceType: LicenceType) {
  updateLicenceType(userId: $userId, licenceType: $licenceType) {
    id
  }
}
`;

export const GET_USERS_QUERY = gql`
query users {
  getUsers{
    id
    firstName
    lastName
  }
}
`;

export interface GetUsersResponse {
  getUsers: User[];
  loading: boolean;
}